import React, { createContext, useRef } from 'react';
import PropTypes from 'prop-types';

/**
 * React context for Google Maps. Provides a map reference to the children components.
 * @typedef {object} GoogleMapContextType
 * @property {object} current - The reference to the Google Map instance.
 */
const GoogleMapRefContext = createContext({ current: null });

/**
 * Creates a context provider for Google Maps.
 * @function
 * @param {Object} props - The props object.
 * @param {Array|Object} props.children - The child or children components.
 * @returns {JSX.Element} A context provider with a Google Map reference.
 */
export const GoogleMapRefProvider = ({ children }) => {
  const mapRef = useRef(null);

  return <GoogleMapRefContext.Provider value={mapRef}>{children}</GoogleMapRefContext.Provider>;
};

GoogleMapRefProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default GoogleMapRefContext;
